import * as React from "react";
import cs from "classnames";
// UI Frameworks
import { InputNumber as AntdInputNumber } from "antd";
import { InputNumberProps } from "antd/lib/input-number";
// Styles
import styles from "./index.module.scss";

interface IProps extends InputNumberProps {
	children?: React.ReactNode;
}
const InputNumber: React.FC<IProps> = ({ className, children, ...restProps }, ref) => {
	return (
		<AntdInputNumber {...restProps} className={cs(styles.input, className)} ref={ref}>
			{children}
		</AntdInputNumber>
	);
};

// @ts-ignore
export default React.forwardRef(InputNumber);
